import React from 'react'
import AppointmentItem from './AppointmentItem'
function PatientAppointments() {
  /*
 "appointmentId": 887,
       
        "dateAppointment": "2024-04-19",
        "startTime": "15:30",
        "endTime": "15:45",
        "type": null,
        "reason": null,
        "isConfirmed": 1, 0 = Not Confirmed, 1 = EyeconX Confirmed, 2 = PMS Confirmed, 3 = Canceled
        "doctorName": "Fiona Soong",
        "isEmail": 1, 1 = Yes, 0 = No
        "isSms": 1, 1 = Yes, 0 = No
        "isCall": 1, 1 = Yes, 0 = No
        "isPrebooked": 0, 1 = Yes, 0 = No
        "isFirst": 1, 1 = Yes, 0 = No
        "isSecond": 1,1 = Yes, 0 = No
        "isLast": 1,1 = Yes, 0 = No
        "isSameDay": 1, 1 = Yes, 0 = No
        "prebookedStatus": 1, 1 = Yes (Sent), 0 = No (Not Sent),
        "firstStatus": 1, 1 = Yes (Sent), 0 = No (Not Sent),
        "secondStatus": 1, 1 = Yes (Sent), 0 = No (Not Sent),
        "lastStatus": 1, 1 = Yes (Sent), 0 = No (Not Sent),
        "sameDayStatus": 1, 1 = Yes (Sent), 0 = No (Not Sent),
        "prebookedSentType": 1, 0-not sent, 1-email, 2-sms, 3-call, 4-livecall
        "firstSentType": 1, 0-not sent, 1-email, 2-sms, 3-call, 4-livecall
        "secondSentType": 1, 0-not sent, 1-email, 2-sms, 3-call, 4-livecall
        "lastSentType": 1, 0-not sent, 1-email, 2-sms, 3-call, 4-livecall
        "sameDaySentType": 1, 0-not sent, 1-email, 2-sms, 3-call, 4-livecall
        "datePrebooked": null, 
        "dateFirst": "2024-02-25T23:35:45",
        "dateSecond": "2024-03-16T23:35:55",
        "dateLast": "2024-03-24T23:36:05",
        "dateSameDay": "2024-03-25T23:36:10",
  */
  return (
    <>
      <AppointmentItem/>
      <AppointmentItem/>

     
    </>
  )
}

export default PatientAppointments